var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 153.01 144.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#0078d4;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -591.52,
    y1: 199.42,
    x2: -621.62,
    y2: 110.52,
    gradientTransform: "matrix(1.6, 0, 0, -1.6, 1010.57, 339.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -594.69,
    y1: 160.21,
    x2: -601.69,
    y2: 157.81,
    gradientTransform: "matrix(1.6, 0, 0, -1.6, 1010.57, 339.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -585.09,
    y1: 211.8,
    x2: -552.09,
    y2: 123.9,
    gradientTransform: "matrix(1.6, 0, 0, -1.6, 1010.57, 339.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,0h45.3l-47,139.2a7.21,7.21,0,0,1-6.8,4.9H7.21A7.17,7.17,0,0,1,0,136.9a5.87,5.87,0,0,1,.4-2.3L44.11,4.9A7.21,7.21,0,0,1,50.91,0H51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.71,93.4H45a3.33,3.33,0,0,0-3.3,3.3,3.19,3.19,0,0,0,1.1,2.4l46.1,43a6.87,6.87,0,0,0,4.9,1.9h40.6l-17.7-50.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51,0a7.3,7.3,0,0,0-6.9,5L.41,134.5a7.24,7.24,0,0,0,4.3,9.2,6.72,6.72,0,0,0,2.4.4h36.1a7.73,7.73,0,0,0,5.9-5l8.7-25.7,31.1,29a7.07,7.07,0,0,0,4.6,1.7H134l-17.8-50.7H64.41L96.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.81,4.9A7.21,7.21,0,0,0,102,0H51.61a7.21,7.21,0,0,1,6.8,4.9l43.8,129.7a7.15,7.15,0,0,1-4.5,9.1,5.87,5.87,0,0,1-2.3.4h50.4a7.17,7.17,0,0,0,7.2-7.2,5.87,5.87,0,0,0-.4-2.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.968b7e44efd01c84c420a57546064708.svg";
export { ForwardRef as ReactComponent };